
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function useNavigationManagement() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Add a history entry when not on home page to prevent app exit
    const isHomePage = location.pathname === '/';
    
    if (!isHomePage) {
      // Push current state to prevent back button from exiting app
      window.history.pushState(null, '', window.location.href);
      
      const handlePopState = (event: PopStateEvent) => {
        // Prevent default back behavior
        event.preventDefault();
        
        // Navigate back using React Router instead of browser back
        navigate(-1);
      };

      window.addEventListener('popstate', handlePopState);
      
      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [location.pathname, navigate]);
}
